
import SignIn from "../Auth/Signin";

// Dashboard
import Dashboard from "../Screens/Dashboard";

// Venue
import VenueMain from "../Screens/Venue/VenueMain";
import VenueCreate from "../Screens/Venue/VenueCreate";
import VenueEdit from "../Screens/Venue/VenueEdit";
import VenueView from "../Screens/Venue/VenueView";

// Reservation
import ReservationMain from "../Screens/Reservation/ReservationMain";
import ReservationCreate from "../Screens/Reservation/ReservationCreate";
import ReservationEdit from "../Screens/Reservation/ReservationEdit";
import ReservationView from "../Screens/Reservation/ReservationView";

// Device
import DeviceMain from "../Screens/Device/DeviceMain";

// User
import UserMain from "../Screens/User/UserMain";
import UserCreate from "../Screens/User/UserCreate";
import UserEdit from "../Screens/User/UserEdit";

// Settings
import Settings from "../Screens/Settings/Settings";

// Activity Log
import ActivityLog from "../Screens/ActivityLog/ActivityLog";

// Errors
import Error400 from "../Components/Pages/ErrorPages/ErrorPage400";
import Error401 from "../Components/Pages/ErrorPages/ErrorPage401";
import Error403 from "../Components/Pages/ErrorPages/ErrorPage403";
import Error404 from "../Components/Pages/ErrorPages/ErrorPage404";
import Error500 from "../Components/Pages/ErrorPages/ErrorPage500";
import Error503 from "../Components/Pages/ErrorPages/ErrorPage503";
import Profile from "../Screens/User/Profile";
import TransactionMain from "../Screens/Transaction/TransactionMain";
import Report from "../Screens/Report";

export const routes = [
  // auth
  { path: `${process.env.PUBLIC_URL}/login`, Component: <SignIn /> },

  // dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard`, Component: <Dashboard /> },

  // venues
  { path: `${process.env.PUBLIC_URL}/venues`, Component: <VenueMain /> },
  { path: `${process.env.PUBLIC_URL}/venues/create`, Component: <VenueCreate /> },
  { path: `${process.env.PUBLIC_URL}/venues/edit/:id`, Component: <VenueEdit /> },
  { path: `${process.env.PUBLIC_URL}/venues/view/:id`, Component: <VenueView /> },

  // reservations
  { path: `${process.env.PUBLIC_URL}/reservations`, Component: <ReservationMain /> },
  { path: `${process.env.PUBLIC_URL}/reservations/create`, Component: <ReservationCreate /> },
  { path: `${process.env.PUBLIC_URL}/reservations/edit/:id`, Component: <ReservationEdit /> },
  { path: `${process.env.PUBLIC_URL}/reservations/view/:id`, Component: <ReservationView /> },

  // transactions
  { path: `${process.env.PUBLIC_URL}/transactions`, Component: <TransactionMain /> },

  // devices
  { path: `${process.env.PUBLIC_URL}/devices`, Component: <DeviceMain /> },

  // users
  { path: `${process.env.PUBLIC_URL}/users`, Component: <UserMain /> },
  { path: `${process.env.PUBLIC_URL}/users/create`, Component: <UserCreate /> },
  { path: `${process.env.PUBLIC_URL}/users/edit/:id`, Component: <UserEdit /> },
  { path: `${process.env.PUBLIC_URL}/profile`, Component: <Profile /> },

  // reports
  { path: `${process.env.PUBLIC_URL}/reports`, Component: <Report /> },
  
  // settings
  { path: `${process.env.PUBLIC_URL}/settings`, Component: <Settings /> },

  // activity logs
  { path: `${process.env.PUBLIC_URL}/activity-logs`, Component: <ActivityLog /> },

  // errors
  { path: `${process.env.PUBLIC_URL}/err400`, Component: <Error400 /> },
  { path: `${process.env.PUBLIC_URL}/err401`, Component: <Error401 /> },
  { path: `${process.env.PUBLIC_URL}/err403`, Component: <Error403 /> },
  { path: `${process.env.PUBLIC_URL}/err404`, Component: <Error404 /> },
  { path: `${process.env.PUBLIC_URL}/err500`, Component: <Error500 /> },
  { path: `${process.env.PUBLIC_URL}/err503`, Component: <Error503 /> },
];